var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.label)?_c('span',{staticClass:"tw-rounded tw-font-medium tw-uppercase tw-tracking-wider tw-whitespace-nowrap",class:[_setup.badgeClass, _vm.small ? 'tw-text-[10px] tw-px-1 tw-py-px' : 'tw-text-xs tw-px-2 tw-py-0.5'],attrs:{"title":_setup.tooltip}},[_vm._v(_vm._s(_setup.label))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }